import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { SBAComboBox, SBAMultiSelectCheck } from "../../../../UiComponents/SBADropDown";
import { sbaAxios } from "../../../../utils/sbaAxios";
 
import { getBillingContactsAPI, getBillingGetExistingClientsAPI,getBillingCustomTemplateAPI, getBillingGetExistingInvoiceAPI, invoiceUpdateOrInsertAPI, getInvoiceMappingAPI, getInvoiceNewMappingAPI, insertInvoiceMappingAPI, deleteInvoiceMappingAPI, insertBillingCustomEmailTemplateAPI} from "../../../../../config/apiConfig";
import { useSelector } from "react-redux";
import { SBNotify } from "../../../../utils/sbNotify";
import moment from "moment/moment";
import { SBADrawer } from "../../../../UiComponents/SBADrawer";
import { SBAEditor } from "../../../../UiComponents/SBAEditor";
import { Modal } from "react-bootstrap";
 
const invoiceData={
  "invoiceId": 0,
  "invoiceMappingId": 0,
  "clientBillingId": 0,
  "clientBillingName": "",
  "contactId": 0,
  "contactName": "",
  "basketId": 0,
  "basketName": "",
  "invoiceName": "",
  "fileName": "",
  "attentionName": "",
  "isAttentionOnBottom": false,
  "careOfName": "",
  "isCareOfOnBottom": false,
  "showAccounts": false,
  "modifiedByUserId": 38,
  "modifiedByUserName": "",
  "modifiedDate": new Date().toISOString(),
  "invoiceTemplateId": 0,
  "invoiceTemplate": "",
  "customTemplateId": 0,
  "customTemplate": "Manual",
  "notes": "",
  "accountId": 0,
  "accountName": ""
};
const blankNewTemplate={
  "TemplateId": -1,
  "TemplateTypeID": 9,
  "TemplateType": "",
  "TemplateName": "Create New Template",
  "description": "",
  "FromEmailAddress": "",
  "CC": "",
  "BCC": "",
  "EmailTemplate": "",
  "EmailSubject": "",
  "IsDefault": false,
  "ModifiedDate":new Date().toISOString(),
  "ModifiedBy": 0
}
 
export const Invoice = () => {
  return (
    <div><InvoiceComponent /></div>
  )
}
 
 
const InvoiceComponent = () => {
 
  const [existingInvoice, setExistingInvoice] = useState([]);
  const [existingInvoice1, setExistingInvoice1] = useState([]);
  const [showEditor, setShowEditor] = useState(false);
  const [existingClientBilling, setExistingClientBilling] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [selectedInvoice,setSelectedInvoice]=useState(invoiceData);
  const [templateList,setTemplateList]=useState([]);
  const [invoiceMapping,setinvoiceMapping]=useState([]);
  const [addNewMapping,setAddNewMapping]=useState(false);
  const [newMappingList,setNewMappingList]=useState([]);
 
  const invoiceRef=useRef();
 
  useEffect(() => {
    getExistingClientBilling();
    setContactListFromAPI();
  }, []);
  useEffect(()=>{
    setinvoiceMapping([]);
  },[showEditor]);
  useEffect(()=>{
    getExistingClientBillingInvoice();
  },[showEditor]);
 const getExistingClientBillingInvoice = () => {
    try {
      sbaAxios({ url: getBillingGetExistingInvoiceAPI }).then(res => {
        setExistingInvoice(res);
        setExistingInvoice1(res);
      }).catch(er => {
        setExistingInvoice([]);
        setExistingInvoice1([]);
      });
    } catch (error) {
 
    }
  };
  const setContactListFromAPI = async () => {
    sbaAxios({ url: getBillingContactsAPI }).then(res=>{
      setContactList(res);
    }).catch(eror=>{setContactList([])});
  };
 const getExistingClientBilling = () => {
    try {
      sbaAxios({ url: getBillingGetExistingClientsAPI }).then(res => {
        setExistingClientBilling(res);
      }).catch(error => {
        setExistingClientBilling([]);
      });
    } catch (error) {
 
    }
  };
 
const keyConverter=(data)=>{
  return  {
    "invoiceId": data?.InvoiceId || 0,
    "invoiceMappingId": data?.InvoiceMappingId || 0,
    "clientBillingId": data?.ClientBillingId || 0,
    "clientBillingName": data?.ClientBillingName || "",
    "contactId": data?.ContactId || 0,
    "contactName": data?.ContactName || "",
    "basketId": data?.BasketId || 0,
    "basketName": data?.BasketName || 0,
    "invoiceName": data?.InvoiceName || "",
    "fileName": data?.FileName || '',
    "attentionName": data?.AttentionName || '',
    "isAttentionOnBottom": data?.IsAttentionOnBottom ||  false,
    "careOfName": data?.CareOfName || '',
    "isCareOfOnBottom": data?.IsCareOfOnBottom,
    "showAccounts": data?.ShowAccounts ||  false,
    "modifiedByUserId": data?.ModifiedByUserId || 0,
    "modifiedByUserName": data?.ModifiedByUserName  || '',
    "modifiedDate": data?.ModifiedDate || new Date().toISOString(),
    "invoiceTemplateId": data?.InvoiceTemplateId || 0,
    "invoiceTemplate": data?.InvoiceTemplate,
    "customTemplateId": data?.CustomTemplateId || 0,
    "customTemplate": data?.CustomTemplate || "",
    "notes": data?.Notes || "",
    "accountId": data?.AccountId || 0,
    "accountName": data?.AccountName|| ""
  }
}
  const ActionColumnRenderer = (e) => {
    try {
      return <div className="actions-cell">
        <i className="fas fa-edit" style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={() => {editInvoice(e)}} ></i>
        {/* <i className="fa fa-trash" style={{ color: "red", margin: "0 8px", cursor: "pointer" }} ></i> */}
      </div>
    } catch (error) {
 
    }
  }
  const columnDefs = [
    { headerName: "Contact Name ", field: "ContactName" ,headerTooltip:'Contact Name'},
    { headerName: "Account Name", field: "AccountName",  headerTooltip:'Account Name'},
    { headerName: "Invoice Name", field: "InvoiceName",headerTooltip:'Invoice Name'},
    { headerName: "File Name", field: "FileName",headerTooltip:'File Name'},
    { headerName: "Attention Name", field: "AttentionName" ,headerTooltip:'Attention Name'},
    { headerName: "C/O Name", field: "CareOfName" ,headerTooltip:'CareOfName'},
    { headerName: "Incl. Account List", field: "ShowAccounts" ,headerTooltip:'Incl. Account List'},
    { headerName: "Template", field: "InvoiceTemplate" ,headerTooltip:'Template'},
    { headerName: "Custom Template", field: "CustomTemplate" ,headerTooltip:'Custom Template'},
    { headerName: "Notes", field: "Notes" ,headerTooltip:'Notes'},
    { headerName: "Edit", field: "Edit", floatingFilter: false , cellRenderer:ActionColumnRenderer},
 
  ];
 const DeleteRenderer=(e)=>{
  return <div className="actions-cell">
        <i className="fa fa-trash" style={{ color: "red", margin: "0 8px", cursor: "pointer" }} onClick={()=>{deletePortfolioMapping(e.data.InvoiceMappingId,e.data.InvoiceId)}} ></i>
      </div>
 }
  const mappingColumnDefs = [
    { headerName: "Client Billing Name ", field: "ClientBillingName" },
    { headerName: "Portfolio Name", field: "PortfolioName" },
    { headerName: "Modified By", field: "ModifiedByUserName" },
    { headerName: "Modified Date", field: "ModifiedDate"  ,valueFormatter:(e)=>(moment(e.value).format("MM/DD/yyyy"))},
    { headerName: "Delete", field: "Delete", cellRenderer:DeleteRenderer }
  ];
  
  const addNewInvoice = async () => {
    try {
      const templateList=await getCustomTemplates();
      setTemplateList(templateList);
      setSelectedInvoice(invoiceData);
      setShowEditor(true);
    } catch (error) {
 
    }
  };
  const FetchtemplateList=async()=>{
    try {
      const templateList=await getCustomTemplates();
      setTemplateList(templateList);
    } catch (error) {
      
    }
  }
  const editInvoice=async (e)=>{
    try {
      const templateList=await getCustomTemplates();
      setTemplateList(templateList);
 
      setSelectedInvoice(keyConverter(e.data));
      setShowEditor(true);
    } catch (error) {
      
    }
  }
  const getCustomTemplates=async()=>{
    try {
      const res=await sbaAxios({url:getBillingCustomTemplateAPI});      
      return [blankNewTemplate,...res];
    } catch (error) {
      return [];
    }
  };
  const fetchInvoiceMapping=async(invoice)=>{
    try {
      const data=await sbaAxios({url:getInvoiceMappingAPI+"?invoiceId="+invoice});
      setinvoiceMapping(data);
    } catch (error) {
      setinvoiceMapping([]);
    }
  };
  const getNewMappingRecords=async(id)=>{
    try {
   const res=   await sbaAxios({url:getInvoiceNewMappingAPI+"?invoiceId="+id});
   return res;
    } catch (error) {
      return [];
    }
  };
  const addMapping=async()=>{
    try {
    const selectedInvoice=  invoiceRef.current.api.getSelectedRows();
    if(selectedInvoice.length>0)
    {
      const invoiceRecord=selectedInvoice[0];
      setAddNewMapping(true);
      const newMappingList=await getNewMappingRecords(invoiceRecord.InvoiceId);
      setNewMappingList(newMappingList);
    }
    else {
      SBNotify({Msg:"Please Select Any Invoice To Add Mapping" ,type:'error'});
    }
    } catch (error) {
      
    }
  };
  const deletePortfolioMapping=async(mappingId,invoiceId)=>{
    try {
      await sbaAxios({url:deleteInvoiceMappingAPI+mappingId}).then(res=>{
        fetchInvoiceMapping(invoiceId);
        SBNotify({Msg:"Portfolio Mapping Removed Successfully"});
      })
    } catch (error) {
      
    }
  }
  const saveMapping=async (data)=>{
    try { 
      const selectedInvoice=  invoiceRef.current.api.getSelectedRows();
      if(selectedInvoice.length>0)
      {
        
        const invoiceRecord=selectedInvoice[0];
        await insertMappingRecords(invoiceRecord.InvoiceId,data.PortfolioId).then(async(res)=>{
          fetchInvoiceMapping(invoiceRecord.InvoiceId);
        });
        setAddNewMapping(false);
        SBNotify({Msg:"Portfolio Mapped Succesfully"});
      }
    } catch (error) {
      
    }
  };
  const insertMappingRecords = async (invoiceId,portfolioId)=>{
    try {
     const resposnse= await  sbaAxios({url:insertInvoiceMappingAPI+`?invoiceId=${invoiceId}&portfolioId=${portfolioId}`});
    } catch (error) {
      
    }
  };
  return <>
    {!showEditor && <> 
      <div className="row">
        <div className="col-md-8">

        <div className="d-flex">
          <div className="w-50">
          <label className="my-2 label">Invoice Name</label>
          < input type='text' className="form-control" onChange={(e)=>{setExistingInvoice(item=>(existingInvoice1.filter(f=>f.InvoiceName.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase()))))}}></input>
          </div>
          <button className="p-sm-btn ms-auto row-item" onClick={() => { addNewInvoice() }}> <i className="fa-plus fa-solid"></i>Add</button>
        </div>
        </div>
        <div className="col-md-4">
        <div className="d-flex">
          <button className="p-sm-btn ms-auto" onClick={() => { addMapping() }}> <i className="fa-plus fa-solid"></i>Portfolio</button>
        </div>
        </div>
            
       
        </div>
    <div className="row">
           
      <div className="col-md-8">
        
        <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
          <AgGridReact 
           columnDefs={columnDefs}
           onRowClicked={(e)=>{fetchInvoiceMapping(e.data.InvoiceId)}} 
           rowSelection="single" 
           rowData={existingInvoice} 
           defaultColDef={defaultColumnDef}
           ref={invoiceRef}
           ></AgGridReact>
        </div>
      </div>
      <div className="col-md-4">
      
        <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
          <AgGridReact columnDefs={mappingColumnDefs} rowData={invoiceMapping} defaultColDef={defaultColumnDef}></AgGridReact>
        </div>
      </div>
      </div></>}
    {showEditor && <>
      <EditOrAddNewInvoice  existingInvoice={existingInvoice} FetchtemplateList={FetchtemplateList} invoice={selectedInvoice}  templateList={templateList} show={showEditor} setShow={setShowEditor} contactList={contactList}  clientBillingList={existingClientBilling}/>
    </>}
    {addNewMapping && 
    <AddNewMapping open={addNewMapping} setopen={setAddNewMapping} data={newMappingList} saveMapping={saveMapping} /> }
  </>
};
 
const EditOrAddNewInvoice = ({ FetchtemplateList,invoice,show,existingInvoice, setShow ,clientBillingList ,contactList ,templateList  }) => {
  const [selectedInvoice,setSelectedInvoice]=useState(invoice);
  const Gstate = useSelector(state => state);
  const taxEntityList = Gstate?.investorAccounts?.taxEntityList || [];
  const TemplateId=selectedInvoice.invoiceTemplateId;
  const SelectedTemplate=templateList.find(item=>item.TemplateId==TemplateId);
  useEffect(() => {
    setSelectedInvoice(invoice);
  }, [invoice]);
  const handleChange=(e,id,name,valName,valId)=>{
    const value=e?.value;
    if(value){
      setSelectedInvoice(values=>({...values,[name]:value[valName],[id]:value[valId]}))
    }
    else
    {
      setSelectedInvoice([]); 
    }
  };
  const handleTextChange=(e,name)=>{
    const text=e.target.value || "";
    
      setSelectedInvoice(value=>({...value,[name]:text}))
    
  };
  const handleCheckChange=(e,name)=>{
  const res=e.target.checked || false;
  setSelectedInvoice(value=>({...value,[name]:res}))
 
  };
  const SaveInvoice=()=>{
    const saveData= {
        "invoiceId": selectedInvoice?.invoiceId || 0,
        "invoiceMappingId": selectedInvoice?.invoiceMappingId || 0,
        "clientBillingId": selectedInvoice?.clientBillingId || 0,
        "clientBillingName": selectedInvoice?.clientBillingName || "",
        "contactId": selectedInvoice?.contactId || 0,
        "contactName": selectedInvoice?.contactName || "",
        "basketId": selectedInvoice?.basketId || 0,
        "basketName": selectedInvoice?.basketName || 0,
        "invoiceName": selectedInvoice?.invoiceName || "",
        "fileName": selectedInvoice?.fileName || '',
        "attentionName": selectedInvoice?.attentionName || '',
        "isAttentionOnBottom": selectedInvoice?.isAttentionOnBottom ||  false,
        "careOfName": selectedInvoice?.careOfName || '',
        "isCareOfOnBottom": selectedInvoice?.isCareOfOnBottom,
        "showAccounts": selectedInvoice?.showAccounts ||  false,
        "modifiedByUserId": selectedInvoice?.modifiedByUserId || 0,
        "modifiedByUserName": selectedInvoice?.modifiedByUserName  || '',
        "modifiedDate": selectedInvoice?.modifiedDate || new Date().toISOString(),
        "invoiceTemplateId": selectedInvoice?.invoiceTemplateId || 0,
        "invoiceTemplate": selectedInvoice?.invoiceTemplate,
        "customTemplateId": selectedInvoice?.customTemplateId || 0,
        "customTemplate": selectedInvoice?.customTemplate || "",
        "notes": selectedInvoice?.notes || "",
        "accountId": selectedInvoice?.accountId || 0,
        "accountName": selectedInvoice?.accountName|| ""
      };
      const existInvoice= existingInvoice.find(item=>item.InvoiceName.toLowerCase()==saveData.invoiceName.toLowerCase())
      if(!selectedInvoice.invoiceName){
        SBNotify({Msg:'Please Enter the Invoice Name ',type:"error"});
        return;
      }
      if(selectedInvoice.invoiceId==0 && existInvoice?.InvoiceName)
      {
        SBNotify({Msg:'Invoice Name Already Exist',type:"error"});
        return;
      }
      if(selectedInvoice.contactId==0) 
      {
        SBNotify({Msg:'Please Select A Contact',type:"error"});
        return;
      } if(selectedInvoice.clientBillingId==0) 
      {
        SBNotify({Msg:'Please Select A Client Billing',type:"error"});
        return;
      }
     
     
     
      sbaAxios({url:invoiceUpdateOrInsertAPI, data:saveData ,method:'post'}).then(res=>{
      setShow(false);
      if(selectedInvoice.invoiceId==0)
      SBNotify({Msg:"Invoice Created Succesfully"});
      else
      SBNotify({Msg:"Invoice  Updated Succesfully"});

    }).catch(()=>{});
  };

  const getCustomTemplates=async()=>{
    try {
      const res=await sbaAxios({url:getBillingCustomTemplateAPI});      
      return [blankNewTemplate,...res];
    } catch (error) {
      return [];
    }
  };
  const setUpdatedTemplate=async(templateId)=>{
    const templist=await getCustomTemplates();
    const selectedTemplate=templist.find(item=>item.TemplateId==templateId);
    setSelectedInvoice(item=>({...item,'invoiceTemplate':selectedTemplate?.TemplateName,'invoiceTemplateId':selectedTemplate?.TemplateId}));

  }
  return <div className="my-2 p-2">
    <div>
      {selectedInvoice?.invoiceId==0 ? "New Invoice" : "Edit Invoice"}
    </div>
    <div className="d-flex">
      <button className="s-sm-btn ms-auto" onClick={() => setShow(false)}>
        Cancel
      </button>
      <button className="p-sm-btn mx-2" onClick={() => {SaveInvoice() }}>
        Save
      </button>
    </div>
    <div className="row">
      <div className="col-md-4">
        <div>
          <label className="my-2 label">Contact Name</label>
          <div>
 
          <SBAComboBox
              className='w-75'
              data={contactList}
              value={{ContactId:selectedInvoice.contactId,ContactName:selectedInvoice.contactName}}
              textField={"ContactName"}
              valueField={"ContactId"}
              onChange={(e)=>{handleChange(e,"contactId","contactName","ContactName","ContactId")}}
            />
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div>
          <label className="my-2 label">Client Billing Name</label>
          <div>
            <SBAComboBox
              className='w-75'
              data={clientBillingList}
              value={{ClientBillingId:selectedInvoice.clientBillingId,ClientBillingName:selectedInvoice.clientBillingName}}
              textField={"ClientBillingName"}
              valueField={"ClientBillingId"}
              onChange={(e)=>{handleChange(e,"clientBillingId","clientBillingName","ClientBillingName","ClientBillingId")}}
 
            />
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div>
          <label className="my-2 label">Invoice Name</label>
          <div>
            <input type="text"
              className="w-75 form-control"
              defaultValue={selectedInvoice.invoiceName}
              onChange={(e)=>{handleTextChange(e,'invoiceName')}}
            />
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div>
          <label className="my-2 label">File Name</label>
          <div>
            <input type="text"
              className="w-75 form-control"
              defaultValue={selectedInvoice.fileName}
              onChange={(e)=>{handleTextChange(e,'fileName')}}
 
            />
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div>
          <label className="my-2 label">Include Accounts</label>
          <div>
            <input type="checkbox"
            checked={selectedInvoice.showAccounts}
            onChange={(e)=>{handleCheckChange(e,'showAccounts')}}
            />
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div>
          <label className="my-2 label">Account Override</label>
          <div>
          <SBAComboBox
              className='w-75'
              data={taxEntityList}
              value={{TaxEntityId:selectedInvoice.accountId,TaxEntityName:selectedInvoice.accountName}}
              textField={"TaxEntityName"}
              valueField={"TaxEntityId"}
              onChange={(e)=>{handleChange(e,'accountId','accountName','TaxEntityName','TaxEntityId')}}
 
            />
          </div>
        </div>
      </div>
      <div className="col-md-4">
      <div>
        <label className="my-2 label">Attention Name</label>
        <div>
          <input type="text"
            className="w-75 form-control"
            defaultValue={selectedInvoice.attentionName}
            onChange={(e)=>{handleTextChange(e,'attentionName')}}
          />
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div>
        <label className="my-2 label">Move Attention Name to bottom</label>
        <div>
          <input type="checkbox"
          checked={selectedInvoice.isAttentionOnBottom}
          onChange={(e)=>{handleCheckChange(e,'isAttentionOnBottom')}}
          />
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div>
        <label className="my-2 label">C/O Name</label>
        <div>
          <input type="text"
            className="w-75 form-control"
            defaultValue={selectedInvoice.careOfName}
            onChange={(e)=>{handleTextChange(e,'careOfName')}}
 
          />
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div>
        <label className="my-2 label">Move C/O Name to bottom</label>
        <div>
          <input type="checkbox"
            checked={selectedInvoice.isCareOfOnBottom}
            onChange={(e)=>{handleCheckChange(e,'isCareOfOnBottom')}}
 
          />
        </div>
      </div>
    </div>
    <div className="col-md-8">
      <div>
        <label className="my-2 label">Notes</label>
        <div>
          <textarea
            className="w-75 form-control"
            defaultValue={selectedInvoice.notes}
            onChange={(e)=>{handleTextChange(e,'notes')}}
          />
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div>
        <label className="my-2 label">Template</label>
        <div>
        <SBAComboBox
              className='w-75'
              data={templateList}
              textField={"TemplateName"}
              valueField={"TemplateId"}
              value={{TemplateId:selectedInvoice?.invoiceTemplateId,TemplateName:selectedInvoice?.invoiceTemplate}}
              onChange={(e)=>{handleChange(e,'invoiceTemplateId','invoiceTemplate','TemplateName','TemplateId')}}
            />
        </div>
      </div>
    </div>
    </div>
    {SelectedTemplate?.TemplateName!=="Manual"  && <EmailSection setUpdatedTemplate={setUpdatedTemplate} templateList={templateList} FetchtemplateList={FetchtemplateList} emailDetails={SelectedTemplate} />}
  </div>
};

const AddNewMapping = ({ open, setopen, data , saveMapping }) => {
  const [selectedMapping,setSelectedMapping]=useState(null);
  const addMappingData=()=>{
    try {
      if(selectedMapping?.PortfolioId)
      {
        saveMapping(selectedMapping)
      }
      else{
        SBNotify({Msg:'Please Select A Portfolio To Map',type:"error"});
      }
    } catch (error) {
      
    }
  }
  return <>
    <SBADrawer
      open={open}
      setOpen={setopen}
      title={"Insert Invoice Mapping"}
    >
      <div>
        <div>
          <div className="mb-4">
            <label className="mb-1 ms-2 fw-semibold fs-12">
              Portfolio Name
              <span className="mandatory">*</span>
            </label>
 
            <div>
              <SBAComboBox
                className="w-50"
                data={data}
                textField={"PortfolioName"}
                valueField={"PortfolioId"}
                onChange={(e)=>{if(e.value){setSelectedMapping(e.value)}}}
                popupSettings={{ className: "modalDD" }}
              />
 
            </div>
          </div>
 
        </div>
      </div>
      <div className="mt-4">
        <button className="s-sm-btn mx-1" onClick={() => { setopen(false)}}>
          Cancel
        </button>
        <button className="p-sm-btn mx-1" onClick={() => {addMappingData()}}>
          Save
        </button>
      </div>
    </SBADrawer>
 
  </>
};
 
const defaultColumnDef = {
  flex: 1,
  // minWidth: 100,
  resizable: true,
  enableValue: true,
  enableRowGroup: true,
  sortable: true,
  autoHeaderHeight: true
};
 
const EmailSection=({emailDetails , FetchtemplateList , templateList ,setUpdatedTemplate })=>{
  const [emailTemplate,setEmailTemplate]=useState(emailDetails);
  const [emailContent,setEmailContent]=useState(emailDetails?.EmailTemplate);
  const [showModal,setShowModal]=useState(false);
  useEffect(()=>{
    
    setEmailContent(emailDetails?.EmailTemplate);
    if(emailDetails?.TemplateId==-1)
    {
      setEmailTemplate({...emailDetails,TemplateName:""});
    }
    else {
      setEmailTemplate(emailDetails);
    }
  },[emailDetails]);
  const saveTemplate=(template)=>{
    sbaAxios({url:insertBillingCustomEmailTemplateAPI , data:template , method:"post"}).then(res=>{
      if(template.TemplateId==0)
      SBNotify({Msg:'New Billing Custom Template Created Succesfully'});
      else 
      SBNotify({Msg:'Template updated Succesfully'});
      FetchtemplateList();
      setUpdatedTemplate(res);
    }).catch(er=>{
      SBNotify({Msg:'Error Occured' , type:"error"});
    });
  }
  const saveTemplateAs=()=>{
    const preparedData={
      "templateId": 0,
      "templateTypeID": emailTemplate.TemplateTypeID,
      "templateType": emailTemplate.TemplateType,
      "templateName":emailTemplate.TemplateName,
      "description":emailTemplate.description,
      "fromEmailAddress":emailTemplate.FromEmailAddress,
      "cc":emailTemplate.CC,
      "bcc":emailTemplate.BCC,
      "emailTemplate":emailTemplate.EmailTemplate,
      "emailSubject":emailTemplate.EmailSubject,
      "isDefault": emailTemplate.IsDefault,
      "modifiedDate" :new Date().toISOString(),
      "modifiedBy":0
    };
    if(!emailTemplate?.TemplateName)
    {
      SBNotify({Msg:'Please Enter the Name' , type:"error"});
      return;
    }
    const ExistingTemplate=templateList.find(item=>item.TemplateName.toLowerCase()==emailTemplate.TemplateName.toLowerCase())
    if(ExistingTemplate?.TemplateName)
    {
      SBNotify({Msg:'Template Name Already Exist' , type:"error"});
      return;
 
    };
    saveTemplate(preparedData);
    setShowModal(false);
 
  };
  const updateTemplate=()=>{
    const preparedData={
      "templateId": emailTemplate.TemplateId,
      "templateTypeID": emailTemplate.TemplateTypeID,
      "templateType": emailTemplate.TemplateType,
      "templateName":emailTemplate.TemplateName,
      "description":emailTemplate.description,
      "fromEmailAddress":emailTemplate.FromEmailAddress,
      "cc":emailTemplate.CC,
      "bcc":emailTemplate.BCC,
      "emailTemplate":emailTemplate.EmailTemplate,
      "emailSubject":emailTemplate.EmailSubject,
      "isDefault": emailTemplate.IsDefault,
      "modifiedDate" :new Date().toISOString(),
      "modifiedBy":0
    };
    saveTemplate(preparedData);
  };
  const HandleOnChange=(name, value)=>{
    setEmailTemplate(val=>{
      return {...val,[name]:value}}
      );
  };
  return <> { <>
        <div className="mt-3 p-3 border rounded">
            <div className="row" >
                <div className="col-md-6">
                    <div className="my-2">
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            Name
                        </label>
                        <input
                            className="w-100 input-default form-control"
                            type="text"
                            placeholder="Type here"
                            value={emailTemplate?.TemplateName}
                            readOnly ={emailTemplate?.TemplateId!=-1}
                            onChange={(e) => { HandleOnChange('TemplateName', e.target.value) }}
                        />
                    </div>
                    <div className="my-2">
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            Description
                        </label>
                        <input
                            className="w-100 input-default form-control"
                            type="text"
                            placeholder="Type here"
                            value={emailTemplate?.description}
                            onChange={(e) => { HandleOnChange('description', e.target.value) }}
                        />
                    </div>
 
                    <div className="my-2" >
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            From
                        </label>
                        <div>
                             <input
                            className="w-100 input-default form-control"
                            type="text"
                            placeholder="From Address"
                            value={emailTemplate?.FromEmailAddress}
                            onChange={(e) => { HandleOnChange('FromEmailAddress', e.target.value) }}
                        />
                        </div>
                    </div>
                    <div className="my-2">
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            CC
                        </label>
                        <div>
                        <input
                            className="w-100 input-default form-control"
                            type="text"
                            placeholder="CC Address"
                            value={emailTemplate?.CC}
                            onChange={(e) => { HandleOnChange('CC', e.target.value) }}
                        />
                        </div>
                    </div>
                    <div className="my-2" >
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            BCC
                        </label>
                        <div>
                        <input
                            className="w-100 input-default form-control"
                            type="text"
                            placeholder="BCC Address"
                            value={emailTemplate?.BCC}
                            onChange={(e) => { HandleOnChange('BCC', e.target.value) }}
                        />
                        </div>
                    </div>
                   
                    <div className="my-2" >
                        <div className="col-md-12">
                            <label className="mb-1 ms-2 fs-12 fw-semibold">
                                Subject
                            </label>
                            <input
                                className="w-100 input-default form-control"
                                type="text"
                                placeholder="Subject"
                                value={emailTemplate?.EmailSubject}
                                onChange={(e) => { HandleOnChange('EmailSubject', e.target.value) }}
 
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <label htmlFor="editor" className="mb-1 ms-2 fs-12 fw-semibold">
                        Description
                    </label>
                    <SBAEditor
                        showTagTool={true}
                        defaultContent={emailContent}
                        onChange={(e) => { setEmailContent(val => e.html); setEmailTemplate(value => ({ ...value, EmailTemplate: e.html })) }}
                        editorHeight={300}
                        setContent={setEmailContent}
                    />
                </div>
            </div>
           
        </div>
        <div className="d-flex mt-2 justify-content-end">
          {emailTemplate?.TemplateId==-1 ?
            <button className="p-sm-btn mx-2" onClick={()=>{saveTemplateAs()}}>Save</button> :
          <>
           <button className="p-sm-btn mx-2" onClick={()=>{setShowModal(true)}} >Save As</button>
          <button className="p-sm-btn mx-2" onClick={()=>{updateTemplate()}}>Update</button>
          
          
          </>}
         
          <Modal show={showModal}  >
                <Modal.Header closeButton onClick={() => { setShowModal(false) }}>
                    <Modal.Title>Enter the Template Name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <input
                            className="w-100 input-default form-control"
                            type="text"
                            placeholder="Type here"
                            onChange={(e) => { HandleOnChange('TemplateName', e.target.value) }}
                        />
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={() => { setShowModal(false) }}>Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={() => { saveTemplateAs() }} >
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </div> </>}
      
  </>
};
